export const basename = (path = "") => path.split("/").reverse()[0];
/**
 * Extract name till extension
 * @param fileName
 * @returns {*}
 */
export const name = fileName => fileName.split(".").slice(0, -1).join(".");
